module.exports = __webpack_public_path__ + "img/Steor-Icon-08.4835f8eb.svg";